import { create } from 'jss';
import jssPreset from 'jss-preset-default';
import jssGlobal from 'jss-plugin-global';
import jssCache from 'jss-plugin-cache';

const hasher = (str) => {
  let hash = 5381;
  let i = str.length;

  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0;
};

class StyleSheet {
  constructor () {
    this.jss = create (jssPreset ());
    this.jss.use (jssCache (), jssGlobal ());
    this.sheet = this.jss.createStyleSheet({});
    this.sheet.attach ();
    this.addedRules = [];
  }
  add (styles) {
    const hash = hasher (JSON.stringify(styles));
    if (!this.addedRules.includes (hash)) {
      styles = { '@global': styles };
      this.sheet.addRules (styles);
      this.addedRules.push (hash);
    }
  }
}

export default new StyleSheet();